"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateToTimeInstant = void 0;
/**
 * Converts a Date object into the integer format expected by ArcGIS Server REST endpoints.
 * @param date A date
 */
function dateToTimeInstant(date) {
    return date.getTime();
}
exports.dateToTimeInstant = dateToTimeInstant;
